const baseUrl = 'https://wcp.symloop.com/api/';
const baseUrlForStorage = 'https://wcp.symloop.com/public';

export { baseUrl };
export { baseUrlForStorage };